import { Injectable } from '@angular/core';
import { Department } from 'BaseDataTypes';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DepartmentService {
  constructor(private http: HttpClient) {}
  /**
   * Gets all departments from the database
   * @returns
   */
  getDepartments(): Observable<Department[]> {
    return this.http.get<Department[]>('/api/department');
  }
  /**
   * Deletes a department by providing departmentd ID and a userId for eventlog, to see who made the change
   * @param departmentId
   * @returns
   */
  deleteDepartment(
    departmentId: number
  )  {
    return this.http.delete('/api/department/' + departmentId, {
      responseType: 'text'
    });
  }

  /**
   * Gets a department by providing department ID
   * @param departmentId
   * @returns
   */
  upsertDepartment(
    department: Department
  ) {
    return this.http.post(
      '/api/department/Upsert',
      department,
      { responseType: 'text' }
    );
  }

}
